import { IconProps } from 'types/icon.type'

export const BarsIcon = (props: IconProps) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Bars icon</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.70801 5C2.70801 4.65482 2.98783 4.375 3.33301 4.375H16.6663C17.0115 4.375 17.2913 4.65482 17.2913 5C17.2913 5.34518 17.0115 5.625 16.6663 5.625H3.33301C2.98783 5.625 2.70801 5.34518 2.70801 5ZM2.70801 10C2.70801 9.65482 2.98783 9.375 3.33301 9.375H16.6663C17.0115 9.375 17.2913 9.65482 17.2913 10C17.2913 10.3452 17.0115 10.625 16.6663 10.625H3.33301C2.98783 10.625 2.70801 10.3452 2.70801 10ZM2.70801 15C2.70801 14.6548 2.98783 14.375 3.33301 14.375H16.6663C17.0115 14.375 17.2913 14.6548 17.2913 15C17.2913 15.3452 17.0115 15.625 16.6663 15.625H3.33301C2.98783 15.625 2.70801 15.3452 2.70801 15Z"
        fill="currentColor"
      />
    </svg>
  )
}
